import { render, staticRenderFns } from "./ConfigParams.vue?vue&type=template&id=59a1cce7&scoped=true&"
import script from "./ConfigParams.vue?vue&type=script&lang=js&"
export * from "./ConfigParams.vue?vue&type=script&lang=js&"
import style0 from "./ConfigParams.vue?vue&type=style&index=0&id=59a1cce7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a1cce7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59a1cce7')) {
      api.createRecord('59a1cce7', component.options)
    } else {
      api.reload('59a1cce7', component.options)
    }
    module.hot.accept("./ConfigParams.vue?vue&type=template&id=59a1cce7&scoped=true&", function () {
      api.rerender('59a1cce7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/vistas/ConfigParams.vue"
export default component.exports